import { Col, ConfigProvider, Modal, Row, Typography } from "antd";
import { UserInfoModalProps } from "types/props";

export const UserInfoModal: React.FC<UserInfoModalProps> = ({
	onClose,
	show,
	user,
}) => {
	return (
		<ConfigProvider
			theme={{
				token: {
					colorBgBase: "#1A1D38",
				},
				components: {
					Modal: {
						contentBg: "#1A1D38",
						colorText: "#fff",
					},
				},
			}}
		>
			<Modal
				title={user?.email}
				open={show}
				onCancel={() => {
					onClose();
				}}
				okButtonProps={{
					style: {
						display: "none",
					},
				}}
				cancelText={"Close"}
			>
				<Row gutter={8}>
					<Col span={12}>
						<Typography.Title level={5}>
							First Name
						</Typography.Title>
						<Typography.Text ellipsis>
							{user?.firstName}
						</Typography.Text>
					</Col>
					<Col span={12}>
						<Typography.Title level={5}>Last Name</Typography.Title>
						<Typography.Text ellipsis>
							{user?.lastName}
						</Typography.Text>
					</Col>
				</Row>
				<Row gutter={8}>
					<Col span={12}>
						<Typography.Title level={5}>
							Free Credits
						</Typography.Title>
						<Typography.Text ellipsis>
							{user?.freeCredits}
						</Typography.Text>
					</Col>
					<Col span={12}>
						<Typography.Title level={5}>Credits</Typography.Title>
						<Typography.Text ellipsis>
							{user?.credits}
						</Typography.Text>
					</Col>
				</Row>
				<Row gutter={8}>
					<Col span={12}>
						<Typography.Title level={5}>
							Organization
						</Typography.Title>
						<Typography.Text ellipsis>
							{user?.organization}
						</Typography.Text>
					</Col>
					<Col span={12}>
						<Typography.Title level={5}>User Type</Typography.Title>
						<Typography.Text>{user?.userType}</Typography.Text>
					</Col>
				</Row>
			</Modal>
		</ConfigProvider>
	);
};
